// extracted by mini-css-extract-plugin
export default {"editcategoryul":"EditProfileLayout_editcategoryul__s6yFL","editcategoryulAnime":"EditProfileLayout_editcategoryulAnime__j4p85","editcategory":"EditProfileLayout_editcategory__BnFtV"};